import { useContext } from "react";
import VspPortalContext from "../../../store/VspPortalContext";
import { CardSwapStatusDto } from "../dtos/CardSwapStatusDto";
import { HttpMethods } from "../../../enums/HttpMethods";
import { NotificationTypes } from "../../../enums/NotificationTypes";
import { VspPortalActions } from "../../../store/VspPortalActions";
import { CardSwapUpdateDto } from "../dtos/CardSwapUpdateDto";
import { CardSwapAuditDto } from "../dtos/CardSwapAuditDto";
import { CardSwapSearchDto } from "../dtos/CardSwapSearchDto";
import { GridSortItem } from "@mui/x-data-grid";
import { useVspPortalHttp } from "../../../hooks/useVspPortalHttp";


export const useCardSwapHttp = ( ): {

    getCardSwapAudits( cardSwapId : number) : Promise< CardSwapAuditDto[] | null >
    , getCardSwapStatuses( ) : Promise< CardSwapStatusDto[] | null >
    , searchCardSwap( cardSwapStatusCodes : string[ ], pageNumber: number, pageSize: number, sorting: GridSortItem, villageCodes : string[ ] ) : Promise< CardSwapSearchDto | null >
    , updateCardSwap( cardSwapUpdateDto : CardSwapUpdateDto ) : Promise< boolean >

} => {

    const { state, dispatch } = useContext( VspPortalContext );
    const { fetchData, getHttpOptions } = useVspPortalHttp( );


    const getCardSwapAudits = async( cardSwapId : number) : Promise< CardSwapAuditDto[] | null > => {

        
        const options = await getHttpOptions ( HttpMethods.Get, undefined );

        const query = `${ process.env.REACT_APP_API_URL }/cardswap/audits/${ cardSwapId }`;

        const response = await fetchData( options, query  );

        if ( response == null ) {

            dispatch({ type: VspPortalActions.SetNotificationType, payload: NotificationTypes.Error });
            dispatch({ type: VspPortalActions.SetNotificationText, payload: 'Error fetching audit records' });
            return null;

        }

        return await response.response?.json( );


    };

    
    const getCardSwapStatuses = async( ) : Promise< CardSwapStatusDto[] | null > => {

        if( state.cardSwapStatuses.length > 0) {
        
            return Promise.resolve( state.cardSwapStatuses );

        }

        
        const options = await getHttpOptions ( HttpMethods.Get, undefined );

        const query = `${process.env.REACT_APP_API_URL}/cardswap/statuses`;

        const response = await fetchData( options, query  );

        if ( response == null ) {

            dispatch({ type: VspPortalActions.SetNotificationType, payload: NotificationTypes.Error });
            dispatch({ type: VspPortalActions.SetNotificationText, payload: 'Error fetching card swap statuses' });

            return null;

        }

        const cardSwapStatuses : CardSwapStatusDto[ ] = await response.response?.json( );
        dispatch({ type: VspPortalActions.SetCardSwapStatuses, payload: cardSwapStatuses });
        return cardSwapStatuses;

    };


    const searchCardSwap = async( cardSwapStatusCodes: string[ ], pageNumber: number, pageSize: number, sorting: GridSortItem, villageCodes : string[ ] ) : Promise< CardSwapSearchDto | null > => {

        
        const options = await getHttpOptions ( HttpMethods.Get, undefined );

        const query = `${process.env.REACT_APP_API_URL}/cardswap/search?cardSwapStatusCode=` 
            + cardSwapStatusCodes.join( '&cardSwapStatusCode=' ) 
            + '&pageNumber=' + pageNumber
            + '&pageSize=' + pageSize
            + '&orderBys=' + sorting.field
            + '&orderByAsc=' + ( sorting.sort === 'asc' ? 'true' : 'false' )
            + '&villageCode=' + villageCodes.join( '&villageCode=' );

        const response = await fetchData( options, query  );

        if ( response == null ) {

            dispatch({ type: VspPortalActions.SetNotificationType, payload: NotificationTypes.Error });
            dispatch({ type: VspPortalActions.SetNotificationText, payload: 'Error searching card swap' });

            return null;

        }

        return await response.response?.json( );

    };


    const updateCardSwap = async( cardSwapUpdateDto : CardSwapUpdateDto ) : Promise< boolean > => {

        
        const options = await getHttpOptions ( HttpMethods.Put, JSON.stringify( cardSwapUpdateDto ) );
        const query = `${process.env.REACT_APP_API_URL}/cardswap/update-cardswap`;
        const response = await fetchData( options, query  );

        if ( response == null || response.statusCode !== 204 ) {

            dispatch({ type: VspPortalActions.SetNotificationType, payload: NotificationTypes.Error });
            dispatch({ type: VspPortalActions.SetNotificationText, payload: 'Error updating card swap' });
            return false;

        }

        dispatch({ type: VspPortalActions.SetNotificationType, payload: NotificationTypes.Success });
        dispatch({ type: VspPortalActions.SetNotificationText, payload: 'Card swap successfully updated!' });

        return true;

    };

    
    return {

        getCardSwapAudits
        , getCardSwapStatuses
        , searchCardSwap
        , updateCardSwap

    };

};